import React from "react";
import Card from "react-bootstrap/Card";
import IDSTable from "./IDSTable";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { S3_URL } from "../services/Constants";
import { validateAndSanitizeUrl } from "../util/common";

const SelectAndAttachedCodes = (props) => {
  const {
    dataCondition,
    isFetchError,
    headCells,
    rows,
    pages,
    nameLabel,
    setPageNoCallback,
    setRecordsPerPageCallback,
    setSelectedRowCallback,
    selectedRows,
    attachedCodes,
    applyCodes,
    isRulesLoincTable,
    isRulesSnomedTable,
    handleShowFilter,
  } = props;

  const buttonsLayout = () => {
    let message = "";
    if (selectedRows.length > 0) {
      message = `${selectedRows.length} ${nameLabel} Codes Selected`;
    }
    return (
      <div
        className="flexCenter generalFont"
        style={{
          marginLeft: "25px",
          fontWeight: "600",
          fontSize: "16px",
          color: "#0040AD",
        }}
      >
        {message}
      </div>
    );
  };

  return (
    <>
      {attachedCodes.length > 0 && (
        <Card
          className="card"
          style={{ marginTop: "40px", marginBottom: "40px" }}
        >
          <Row style={{ padding: "40px 40px 20px 40px" }}>
            <div className="cardBody" style={{ marginBottom: "40px" }}>
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}rules-details-icon.png`}
                style={{
                  width: "20px",
                  height: "18px",
                  marginRight: "15px",
                }}
                alt=""
              ></img>
              <div className="condModalHeader generalFont">{`Attached ${nameLabel} Codes`}</div>
            </div>
          </Row>
          <Row style={{ padding: "0px 40px 40px 40px" }}>
            <IDSTable
              isFetchError={false}
              headCells={headCells}
              rows={attachedCodes.map(row => ({ ...row, conditionName:  dataCondition}))}
              noButtons={true}
            />
          </Row>
        </Card>
      )}
      <Card className="card" style={{ marginTop: "40px" }}>
        <Row style={{ padding: "40px 40px 20px 40px" }}>
          <div className="cardBody">
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}rules-details-icon.png`}
              style={{
                width: "20px",
                height: "18px",
                marginRight: "15px",
              }}
              alt=""
            ></img>
            <div className="condModalHeader generalFont">{`Select ${nameLabel} Codes`}</div>
          </div>
        </Row>
        <Row style={{ padding: "0px 40px 0px 40px" }}>
          {dataCondition ? (
            <IDSTable
              isFetchError={isFetchError}
              setPageNoCallback={setPageNoCallback}
              setRecordsPerPageCallback={setRecordsPerPageCallback}
              headCells={headCells}
              rows={rows}
              pages={pages}
              buttonsLayout={buttonsLayout}
              isRulesSnomedTable={isRulesSnomedTable}
              isRulesLoincTable={isRulesLoincTable}
              handleShowFilter={handleShowFilter}
              setSelectedRowCallback={setSelectedRowCallback}
              dataCondition={dataCondition}
              selectedRows={attachedCodes?.length > 0 && attachedCodes}
            />
          ) : (
            <div className="cardBody centerPositioned">
              {`Select Condition to view available ${nameLabel}s`}
            </div>
          )}

          <Row style={{ marginTop: "10px", marginBottom: "30px" }}>
            <Col className="flexCenter">
              <Button
                className="addNewBtn flexCenter generalFont"
                onClick={applyCodes}
                disabled={
                  selectedRows?.length === 0 && attachedCodes?.length === 0
                }
              >
                <img
                  src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                  alt=""
                  style={{ marginRight: "10px" }}
                ></img>
                {`Apply ${nameLabel} Codes`}
              </Button>
            </Col>
          </Row>
        </Row>
      </Card>
    </>
  );
};

export default SelectAndAttachedCodes;
